import { concat } from './strings';

export default function formatAddress({ address, address2, city, stateName, countryOther, zip } = {}) {
  const line1 = concat([address, address2, city], ', ');
  const line2 = concat([countryOther || stateName, zip], ' ');
  return concat([line1, line2], ', ');
}



// WEBPACK FOOTER //
// ./shared/lib/prettyAddress.js